import { 
  ReportSpecimenPositivityRoute, 
  ReportTestingSummaryRoute, 
  ReportDrugDetailRoute, 
  ReportDailySummaryRoute, 
  ReportIvrCallInComplianceRoute, 
  ReportNoShowRoute 
} from "../../config/Routes";

export enum OnTrackReportType {
  IVRCallInCompliance = 1,
  DailySummary = 2,
  TestSummary = 3,
  SpecimenPositivity = 4,
  DrugDetail = 5,
  NoShow = 6
}
const Reports = [
  ReportSpecimenPositivityRoute, 
  ReportTestingSummaryRoute, 
  ReportDrugDetailRoute, 
  ReportDailySummaryRoute, 
  ReportIvrCallInComplianceRoute,
  ReportNoShowRoute
] as const
export type Report = typeof Reports[number]
export type OnTrackReportRecord = {
  type: OnTrackReportType
  title: string
}
export type OnTrackReport = Record<Report, OnTrackReportRecord>

export default function getOnTrackReport(report: Report) {
  const OnTrackReports: OnTrackReport = {
    [ReportTestingSummaryRoute]: { type: OnTrackReportType.TestSummary, title: "Testing Summary" },
    [ReportSpecimenPositivityRoute]: { type: OnTrackReportType.SpecimenPositivity, title: "Specimen Positivity" },
    [ReportDrugDetailRoute]: { type: OnTrackReportType.DrugDetail, title: "Drug Detail" },
    [ReportDailySummaryRoute]: { type: OnTrackReportType.DailySummary, title: "Daily Summary" },
    [ReportIvrCallInComplianceRoute]: { type: OnTrackReportType.IVRCallInCompliance, title: "IVR Call-In Compliance" },
    [ReportNoShowRoute]: { type: OnTrackReportType.NoShow, title: "No Show" }
  }
  return OnTrackReports[report]
}
